import { render } from "./SlideOverFeeNotices.vue?vue&type=template&id=6231ebb9&scoped=true"
import script from "./SlideOverFeeNotices.vue?vue&type=script&lang=js"
export * from "./SlideOverFeeNotices.vue?vue&type=script&lang=js"

import "./SlideOverFeeNotices.vue?vue&type=style&index=0&id=6231ebb9&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6231ebb9"]])

export default __exports__